import React from "react";

const Batch_starting_date = () => {
  return (
    <div className="notifications">
      <div className="notification__">
        <div className="upload_date">1st Oct 2025</div>
        <hr style={{ width: "100%" }}></hr>
        <div className="notification__heading">Batch Starting Date</div>
        <div>
          {" "}
          <span className="class">Class  VIII </span>: 23rd March 2026
        </div>
        <div>
          <span className="class">Class IX </span> : 23rd March 2026
        </div>
        <div>
          <span className="class">Class X </span> : 23rd March 2026
        </div>
        <div>
          <span className="class">Class XI </span> : 6th April 2026
        </div>
        <div>
          <span className="class">Class XII </span> : 23rd March 2026
        </div>
        <div>
          <span className="class">Class XII pass IIT JEE </span> : 20th April 2026
        </div>
        <div>
          <span className="class">Class XII pass NEET </span> : 4th May 2026
        </div>
      </div>
      <hr style={{ width: "100%" }}></hr>
    </div>
  );
};

export default Batch_starting_date;
